import React, { useEffect, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import purcases from "../../../Data/purchases.json";
import suppliers from "../../../Data/suppliers.json";
import toast from "react-hot-toast";
import { get_all_purchases } from "../../../Controllers/Purchases/Orders";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import formatDateDDMMYYYY from "../../../Main/formatDate";

const SuppliersReport = () => {
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const headers = {
    name: "Suppliers",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Name (A-Z)" },
          { value: 1, label: "Name (Z-A)" },
        ],
      },
      {
        type: "filter",
        name: "catalog",
        placeholder: "Product",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-products",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
    ],
      navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Supplier",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: 0, label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const products = await get_all_purchases(data);
      if (products?.status) {
        setBody(products?.data?.data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <table className="w-full bg-white">
          <thead className="text-gray-500">
            <tr>
              <td className="border p-4">Purchase</td>
              <td className="border p-4">Supplier</td>
              <td className="border p-4">Date</td>
              <td className="border p-4">Due</td>
              <td className="border p-4">Subtotal</td>
              <td className="border p-4">Tax</td>
              <td className="border p-4">Amount</td>
            </tr>
          </thead>
          <tbody>
            {body?.map((value, index) => {
              return (
                <tr>
                  <td className="border p-4">{value?.number}</td>
                  <td className="border p-4">{value?.supplier?.name}</td>
                  <td className="border p-4">
                    {value?.date
                      ? formatDateDDMMYYYY(value?.date)
                      : ""}
                  </td>
                  <td className="border p-4">
                    {formatDateDDMMYYYY(value?.due_date)}
                  </td>
                  <td className="border p-4">{value?.subtotal}</td>
                  <td className="border p-4">{value?.taxamount}</td>
                  <td className="border p-4">{value?.total}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <td className="border p-4"></td>
            <td className="border p-4"></td>
            <td className="border p-4"></td>
            <td className="border p-4"></td>
            <td className="border p-4">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.subtotal),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-4">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.taxamount),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-4">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total),
                  0
                )
                ?.toFixed(3)}
            </td>
          </tfoot>
        </table>
      </Loadercomponent>
    </Header>
  );
};

export default SuppliersReport;
